export default "__VITE_ASSET__BAQE2$qP__"